import Request from '../../utilities/Request.jsx';
import { setPlayer } from './dashboard.js';
import { laterVersion, writeLocalSeen } from '../../react/components/whatsNew/whatsNew.js';

/**
 * Marks the "What's new" notes read up to `version`, for this user on every device. The player is
 * updated at once, so the notes do not come back while the request is in flight or if it fails.
 */
export const markWhatsNewSeen = (version) => (dispatch, getState) => {
	const player = getState().dashboard.player;
	if(!player || !player.id || !version) {
		return Promise.resolve();
	}
	writeLocalSeen(player.id, laterVersion(player.whats_new_seen, version));
	if(laterVersion(player.whats_new_seen, version) !== player.whats_new_seen) {
		dispatch(setPlayer({ ...player, whats_new_seen: version }));
	}
	return Request.apiv1Post('player/whats_new_seen', { version })
		.catch((error) => {
			console.error('Could not record the What\'s new notes as read', error);
		});
};
